// Copyright © 2024 Broadcom Inc. and its subsidiaries. All Rights Reserved.
import * as CONSTANTS from '../../constants';

const initialState = {
  initialData: {
    data: null,
    isLoading: false,
    error: null,
  },
  updatedData: {
    data: null,
    isLoading: false,
    error: null,
  },
}

export default function (state = initialState, action){
  switch (action.type) {
    case CONSTANTS.UPDATE_TENANT_INFO_REQUEST:
      return { ...state, updatedData: { isLoading : true, data: null, error: null } };
    case CONSTANTS.UPDATE_TENANT_INFO_SUCCESS:
      return {
        ...state, updatedData: { data: action.payload || true, isLoading : false, error: null },
      };
    case CONSTANTS.UPDATE_TENANT_INFO_ERROR:
      return { ...state, updatedData: { error: action.payload, data: null, isLoading: false } };

    case CONSTANTS.TENANT_INFO_REQUEST:
      return { ...state, initialData: { isLoading : true, data: null, error: null } };
    case CONSTANTS.TENANT_INFO_SUCCESS:
      return { ...state, initialData: { data: action.payload, isLoading : false, error: null } };
    case CONSTANTS.TENANT_INFO_ERROR:
      return { ...state, initialData: { error: action.payload, data: null, isLoading: false } };

    default:
      return state;
  }
}

export const getTenantsInfo = (state) => state.settings && state.settings.initialData;
export const getUpdateTenantsInfoResponse = (state) => state.settings && state.settings.updatedData;
